import { Box, Typography, Stack } from '@mui/material';
import { FaEye, FaMapLocationDot, FaPencil, FaTrashCan } from "react-icons/fa6";
import { Grid } from "@mui/material";
import Map from '../pages/extra/Map';
import logoLoader from "../pages/extra/camera-small.png";

function CameraGrid({ cols, images, viewMode, onCameraClick, handleAction, markers }) {

  if (!images || images.length === 0) {
    return <Box sx={{ textAlign: 'center', p: 5, color: 'text.secondary' }}>No cameras found for this category.</Box>
  }

  // --- MAP VIEW ---
  if (viewMode === 'map') {
    return (
      <Box>
        {markers ? <Map markers={markers} /> : <>
          <Box sx={{
            width: '100%', bgcolor: '#f9fafb', borderRadius: '12px',
            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
            color: '#9ca3af', mb: 4, border: '2px dashed #5d87dbff'
          }}>
            <Box sx={{ fontSize: '48px', mb: 1, opacity: 0.5 }}>
              <FaMapLocationDot />
            </Box>
            <Typography fontWeight={500}>Map View</Typography>
            <Typography variant="caption" sx={{ mt: 0.5 }}>NO map available</Typography>
          </Box>
        </>}
      </Box>
    );
  }

  // --- LIST VIEW ---
  if (viewMode === 'list') {
    return (
      <Stack spacing={1.5} sx={{ mb: 4 }}>
        {images?.map((item) => (
          <Box
            key={item.id}
            onClick={() => onCameraClick && onCameraClick(item)}
            sx={{
              display: 'flex', alignItems: 'center', gap: 2, bgcolor: 'white', p: 1.5,
              borderRadius: '12px',
              // border: '1px solid #f3f4f6', 
              cursor: 'pointer',
              transition: '0.3s', '&:hover': { boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)' }
            }}
          >
            <Box sx={{ position: 'relative', width: '128px', height: '80px', flexShrink: 0 }}>
              <img src={item.thumbnail} alt={item.title} style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px' }} />
              <Box sx={{
                position: 'absolute', bottom: 4, right: 4, fontSize: '10px', fontWeight: 'bold',
                px: 0.8, py: 0.2, borderRadius: '2px', color: 'white',
                bgcolor: item.camera_type === 'TIMELAPSE' ? '#22c55e' : '#3b82f6'
              }}>
                {item.camera_type}
              </Box>
            </Box>
            <Box sx={{ flex: 1 }}>
              <Typography variant="subtitle1" fontWeight={600} color="#1f2937">{item.camera_name}</Typography>
              <Typography variant="body2" color="#6b7280">{item.created_at}</Typography>
            </Box>
            <Box sx={{ flex: 1 }}>
              <Typography variant="subtitle1" fontWeight={600} color="#1f2937">{item.company_name}</Typography>
              <Typography variant="body2" color="#6b7280">{item.location}</Typography>
            </Box>
            <Box sx={{ flex: 1 }}>
              <Typography variant="subtitle1" fontWeight={600} color="#1f2937">{item.project_name}</Typography>
              <Typography variant="body2" color="#6b7280">{item.location}</Typography>
            </Box>
            <Stack direction="row" spacing={1} onClick={(e) => e.stopPropagation()}>
              {[
                { icon: FaEye, color: '#60a5fa', action: "view_more" },
                { icon: FaMapLocationDot, color: '#60a5fa', action: "map" },
                { icon: FaPencil, color: '#facc15', action: "edit" },
                { icon: FaTrashCan, color: '#f87171', action: "delete" }
              ].map((btn, idx) => (
                <Box key={idx} sx={{
                  color: 'rgba(105, 103, 103, 1)', cursor: 'pointer', fontSize: '16px',
                  transition: 'transform 0.2s',
                  '&:hover': { color: btn.color, transform: 'scale(1.1)' }
                }}>
                  <Box onClick={() => handleAction(btn.action, item)}><btn.icon /></Box>
                </Box>
              ))}
            </Stack>
          </Box>
        ))}
      </Stack>
    );
  }

  // --- GRID VIEW ---

  return (
    <Grid container spacing={1}>
      {images.map((data) => (
        <Grid
          item
          key={data.id}
          size={{ xs: 12, sm: 6, md: 12 / cols }}
        >
          <Box
            className={'camera-bg'}
            key={data.id}
            onClick={() => onCameraClick && onCameraClick(data)}
            sx={{
              position: 'relative',
              borderRadius: '16px',
              overflow: 'hidden',
              cursor: 'pointer',
              boxShadow: '0px 4px 20px 0px rgba(0,0,0,0.1)',
              transition: 'all 0.3s',
              height: cols === 6 ? '105px' : 'auto',
              aspectRatio: cols === 6 ? 'auto' : '2 / 1.5',
              '&:hover': {
                boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
                '& .hover-overlay': { opacity: 1 },
                '& .card-img': { transform: 'scale(1.1)', opacity: 0.6 }
              },
              background: '#00000030'
            }}
          >
            {/* <img src={logoLoader} width='100%' height='100%' /> */}

            <Box
              component="img"
              src={data.thumbnail || logoLoader}
              alt={data.title}
              className="card-img"
              onError={(e) => {
                e.target.src = logoLoader; // fallback image
              }}
              sx={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.5s', opacity: 0.9 }}
            />

            <Box
              className="hover-overlay"
              sx={{
                position: 'absolute', inset: 0, bgcolor: 'rgba(0,0,0,0.4)',
                opacity: 0, transition: 'opacity 0.3s'
              }}
            >
              <Box sx={{
                position: 'absolute', top: 0, left: 0, width: '100%', p: 1.5,
                display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start'
              }}>

                <Typography sx={{
                  color: 'white', fontSize: '13px', fontWeight: 500,
                  lineHeight: 1.2, textShadow: '0 2px 4px rgba(0,0,0,0.5)',
                  maxWidth: '60%',
                  whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'
                }}>
                  {data.camera_name}
                </Typography>

                <Stack direction="row" spacing={1} onClick={(e) => e.stopPropagation()}>
                  {[
                    { icon: FaEye, color: '#60a5fa', action: "view_more" },
                    { icon: FaMapLocationDot, color: '#60a5fa', action: "map" },
                    { icon: FaPencil, color: '#facc15', action: "edit" },
                    { icon: FaTrashCan, color: '#f87171', action: "delete" }
                  ].map((btn, idx) => (
                    <Box key={idx} sx={{
                      color: 'white', cursor: 'pointer', fontSize: '16px',
                      transition: 'transform 0.2s',
                      '&:hover': { color: btn.color, transform: 'scale(1.1)' }
                    }}>
                      <Box onClick={() => handleAction(btn.action, data)}><btn.icon /></Box>
                    </Box>
                  ))}
                </Stack>

              </Box>
            </Box>

          </Box>
        </Grid>
      ))}
    </Grid>
  );
}
export default CameraGrid;